import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

interface WorkerAvailabilityBannerContent {
  title: string;
  description: string;
}

export function useGetWorkerAvailabilityBannerV2Content(): WorkerAvailabilityBannerContent {
  return useCbhFlag(CbhFeatureFlag.WORKER_AVAILABILITY_BANNER_CONTENT, {
    defaultValue: {
      title: "Tap to set your criteria and enable auto-book",
      description: "",
    },
  });
}
